import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import info from '../../../../../assets/images/icons/info.svg';
import FilterRadioButton from '../../../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../../../components/FilterRadioButtonsContainer';
import FormGroup from '../../../../../components/FormGroup';
import Input from '../../../../../components/Input';
import { GetErrorMessageByFieldNameType } from '../../../../../hooks/useErrors';
import { AsideContainer, Group, Container as StyledContainer } from '../styles';

interface CompanyDataInterface {
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  cnpj: string;
  handleCnpjChange: (event: ChangeEvent<HTMLInputElement>) => void;
  cnpjPagto: string;
  handleCnpjPagtoChange: (event: ChangeEvent<HTMLInputElement>) => void;
  pagadorNFSeparada: boolean;
  setPagadorNFSeparada: Dispatch<SetStateAction<boolean>>;
  companyName: string;
  handleCompanyNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  fantasyName: string;
  handleFantasyNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  employeesQty: string | number;
  handleEmployeesQtyChange: (event: ChangeEvent<HTMLInputElement>) => void;
  stateRegistration: string;
  handleStateRegistrationChange: (event: ChangeEvent<HTMLInputElement>) => void;
  municipalRegistration: string;
  handleMunicipalRegistrationChange: (event: ChangeEvent<HTMLInputElement>) => void;
  companyCellphone: string;
  handleCompanyCellphoneChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export default function CompanyData({
  getErrorMessageByFieldName,
  cnpj,
  handleCnpjChange,
  cnpjPagto,
  handleCnpjPagtoChange,
  pagadorNFSeparada,
  setPagadorNFSeparada,
  companyName,
  handleCompanyNameChange,
  fantasyName,
  handleFantasyNameChange,
  employeesQty,
  handleEmployeesQtyChange,
  stateRegistration,
  handleStateRegistrationChange,
  municipalRegistration,
  handleMunicipalRegistrationChange,
  companyCellphone,
  handleCompanyCellphoneChange,
}: CompanyDataInterface) {
  return (
    <StyledContainer>
      <div className="card-title">
        Dados da empresa
      </div>

      <AsideContainer>
        <Group>
          <div className="title">CNPJ</div>
          <FormGroup error={getErrorMessageByFieldName('cnpj')}>
            <Input
              placeholder="Informe o CNPJ de sua empresa"
              value={cnpj}
              onChange={handleCnpjChange}
              autoComplete="new-password"
              error={getErrorMessageByFieldName('cnpj')}
              maxLength={18}
            />
          </FormGroup>
        </Group>

        <Group>
          <div className="title">Razão Social</div>
          <FormGroup error={getErrorMessageByFieldName('companyName')}>
            <Input
              placeholder="Informe a razão social de sua empresa"
              value={companyName}
              onChange={handleCompanyNameChange}
              autoComplete="new-password"
              error={getErrorMessageByFieldName('companyName')}
              maxLength={255}
            />
          </FormGroup>
        </Group>
      </AsideContainer>

      <AsideContainer>
        <Group>
          <div className="title">CNPJ de pagamento / NF</div>
          <FormGroup error={getErrorMessageByFieldName('cnpjPagto')}>
            <Input
              placeholder="Informe se diferente do CNPJ da empresa"
              value={cnpjPagto}
              onChange={handleCnpjPagtoChange}
              autoComplete="new-password"
              error={getErrorMessageByFieldName('cnpjPagto')}
              maxLength={20}
            />
          </FormGroup>
        </Group>
      </AsideContainer>

      <AsideContainer>
        <Group>
          <div className="title">
            Nota Fiscal do CNPJ Pagador Separada?
            {' '}
            <img
              src={info}
              alt="info"
              title="Se o valor do serviço será cobrado em uma nota fiscal do CNPJ PAGADOR, porém separada (Padrão: Não - o valor do serviço será cobrado em uma única nota fiscal pelo CNPJ do pagador)"
              style={{ width: '14px', height: '14px', cursor: 'pointer', verticalAlign: 'middle' }}
            />
          </div>
          <FilterRadioButtonsContainer>
            <FilterRadioButton
              selected={pagadorNFSeparada}
              onClick={() => setPagadorNFSeparada(true)}
            >
              Sim
            </FilterRadioButton>
            <FilterRadioButton
              selected={!pagadorNFSeparada}
              onClick={() => setPagadorNFSeparada(false)}
            >
              Não
            </FilterRadioButton>
          </FilterRadioButtonsContainer>
        </Group>
      </AsideContainer>

      <AsideContainer>
        <Group>
          <div className="title">Nome fantasia</div>
          <FormGroup error={getErrorMessageByFieldName('fantasyName')}>
            <Input
              placeholder="Informe o nome fantasia de sua empresa"
              value={fantasyName}
              onChange={handleFantasyNameChange}
              autoComplete="new-password"
              error={getErrorMessageByFieldName('fantasyName')}
              maxLength={100}
            />
          </FormGroup>
        </Group>

        <Group>
          <div className="title">Quantidade de funcionários</div>
          <FormGroup error={getErrorMessageByFieldName('employeesQty')}>
            <Input
              placeholder="Informe a quantidade de funcionários"
              value={employeesQty}
              onChange={handleEmployeesQtyChange}
              autoComplete="new-password"
              error={getErrorMessageByFieldName('employeesQty')}
            />
          </FormGroup>
        </Group>
      </AsideContainer>

      <AsideContainer>
        <Group>
          <div className="title">Inscrição estadual</div>
          <FormGroup>
            <Input
              placeholder="Caso isento, não preencha"
              value={stateRegistration}
              onChange={handleStateRegistrationChange}
              maxLength={20}
              autoComplete="new-password"
            />
          </FormGroup>
        </Group>

        <Group>
          <div className="title">Inscrição municipal</div>
          <FormGroup>
            <Input
              placeholder="Caso isento, não preencha"
              value={municipalRegistration}
              onChange={handleMunicipalRegistrationChange}
              maxLength={20}
              autoComplete="new-password"
            />
          </FormGroup>
        </Group>
      </AsideContainer>

      <Group>
        <div className="title">Telefone</div>
        <FormGroup>
          <Input
            placeholder="Telefone da empresa"
            value={companyCellphone}
            onChange={handleCompanyCellphoneChange}
            autoComplete="new-password"
          />
        </FormGroup>
      </Group>
    </StyledContainer>
  );
}
